// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".containt {\n  height: 40px !important;\n  width: 300px !important; }\n", "",{"version":3,"sources":["webpack://src/pages/ProductList/style.scss"],"names":[],"mappings":"AAAA;EACI,uBAAsB;EACtB,uBAAsB,EAAA","sourcesContent":[".containt{\n    height: 40px!important;\n    width: 300px!important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
